module.exports = __webpack_public_path__ + "static/media/IssuersApp-logo-vertical.211f41ce.svg";